import EA from 'helpers/init';
import gsap from 'gsap';

export default EA.Methods.controlPopup = ($this) => {
    const body = document.querySelector('body');
    const modal = $this.getAttribute('data-modal');
    const btns = $this;
    const modalContainer = document.querySelector('.modal-container');
    const closeBtn = modalContainer.querySelectorAll('.popup-close');
    const modalOverlay = modalContainer.querySelector('.popup-overlay');
    const tl = gsap.timeline({ paused: true });

    function close() {
        tl.reverse();
        document.querySelector('.' + modal).classList.remove('active');
        modalContainer.classList.remove('active');
        body.classList.remove('overflow');
    }

    function open() {
        tl.play();
        document.querySelector('.' + modal).classList.add('active');
        modalContainer.classList.add('active');
        document.querySelectorAll('.popup-main').forEach(function (element) {
            if (!element.classList.contains(modal)) {
                element.classList.remove('active');
            }
        });
        body.classList.add('overflow');
    }
    
    tl
        .to(`.${modal}`, {
            y: '0%',
            visibility: 'visible',
            stagger: 0.1,
            duration: 0.5,
            ease: 'power3.inOut'
        });

    btns.addEventListener('click', function (e) {
        e.preventDefault();
        open();
    });

    modalOverlay.addEventListener('click', function (e) {
        close();
    });

    closeBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            close();
        });
    });

    document.addEventListener('keydown', function (event) {
        const key = event.key;
        if (key === 'Escape' && body.classList.contains('overflow')) {
            if(document.querySelector(`.${modal}`).classList.contains('active')) {
                close();
            }
        }
    });
};